import { BasicRequest } from "./basicRequest";

export class PublishMoovDefinitionRequest extends BasicRequest{
    public moovDefinitionId!:number;
    public published:boolean = false;

    constructor(){
        super();
    }
}